import JSEncrypt from 'jsencrypt';
import { UserIdentifierEnum } from './user-identifier.enum'

class EncryptedBase
{
    private static PRIVATE_KEY: string;

    constructor(rsaKey: string)
    {
        EncryptedBase.PRIVATE_KEY = rsaKey;
    }

    protected encrypt(msg: string): any
    {
        const encryptor = new JSEncrypt({});

        encryptor.setPublicKey(EncryptedBase.PRIVATE_KEY);

        return encryptor.encrypt(msg);
    }
}

export class SignupEncrypt extends EncryptedBase
{
    public email: string;
    public username: string;
    public firstName: string;
    public lastName: string;
    public passport: string;
    public password: string;
    public cpf: string;
    public cnpj: string;

    constructor(email: string, password: string, username: string, firstName: string, lastName: string, documentId: string, rsaKey: string, documentType: UserIdentifierEnum)
    {
        super(rsaKey);
        this.email = email;
        this.username = username;
        this.password = this.encrypt(password);
        this.firstName = firstName;
        this.lastName = lastName;
        this.cpf = '';
        this.cnpj = '';
        this.passport = '';

        if (documentType === UserIdentifierEnum.External) {
            this.passport = documentId;
        } else if (documentType === UserIdentifierEnum.CNPJ) {
            this.cnpj = documentId;
        } else if (documentType === UserIdentifierEnum.CPF) {
            this.cpf = documentId
        }
    }
}